// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__4W4B2","radio-icon":"Radio_radio-icon__QUxiF","is-checked":"Radio_is-checked__zZsWH"};